import { Session } from '../models/Session';
import { RestrictionType } from '../enums/RestrictionType';
import { UserRestriction } from '../models/UserRestriction';

export const RestrictionHelper = {

  getRestriction: (session: Session | null | undefined, restrictionType: RestrictionType): UserRestriction | null =>
    session?.restrictions?.find(r => r.restrictionType === restrictionType) || null,

  hasRestriction: (session: Session | null | undefined, restrictionType: RestrictionType) =>
    !!RestrictionHelper.getRestriction(session, restrictionType),

  getRestrictionMessage: (session: Session | null | undefined, restrictionType: RestrictionType, genericMessage: string) => {
    const restriction = RestrictionHelper.getRestriction(session, restrictionType);
    return restriction?.reason?.trim() ? restriction.reason : genericMessage;
  }

}
